export default {
    job_name: 'Job Name',
    is_enable: 'Whether to enable',
    add_user: 'Add User',
    query_user: 'Query User',
    search_tip: 'Please search for user information before adding a new user to check if it already exists.',
    input_name: 'Please enter the user name',
    input_mobile: 'Please enter the phone number',
    input_unit: 'Please enter the work unit',
    add_new_user: 'Add New User',
    edit_user: 'Edit User',
    staff_register_address: 'Staff Registration Address',
    channel_open_status: 'Channel Open Status',
    reg_deadline: 'Registration Deadline',
    login_page_note: 'Channel Registration Login Page Instruction Text',
    index_page_note: 'Channel Registration Login Home Page Instruction Text',
    open_link: 'Open Link',
    add_staff: 'Add Staff',
    onsite_job: 'On-site Job',
    identity: 'Identity',
    sign_status: 'Sign-in Status',
    reg_time: 'Registration Time',
    volunteer: 'Conference Volunteer',
    supplier_staff: 'Supplier Staff',
    organizer_staff: 'Organizer Staff',
    signed: 'Signed In',
    unsigned: 'Not Signed In',
    enabled: 'Enabled',
    disabled: 'Disabled',
    select_staff_identity: 'Please select the staff identity'
};
